module.exports = __webpack_public_path__ + "media/images/img-realestate-9-64e6a1c1.png";